import Layout from './components/Layout';
import { routes } from './router';

/**
 * 根组件
 * 接入 Layout + Router
 * 路由配置见 router.tsx
 */
export default function App() {
  return <Layout>{routes}</Layout>;
}
